import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CollabConflictResolutionDialogModule } from '@portal-core/collab/components/collab-conflict-resolution-dialog/collab-conflict-resolution-dialog.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { PluralizeModule } from '@portal-core/general/pipes/pluralize/pluralize.module';
import { PathListItemModule } from '@portal-core/ui/list/components/path-list-item/path-list-item.module';
import { CollabPullDialogComponent } from './collab-pull-dialog.component';

@NgModule({
  declarations: [
    CollabPullDialogComponent
  ],
  imports: [
    CollabConflictResolutionDialogModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    LoaderModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatListModule,
    MatSnackBarModule,
    MatToolbarModule,
    PathListItemModule,
    PluralizeModule
  ],
  exports: [
    CollabPullDialogComponent
  ]
})
export class CollabPullDialogModule { }
